import React from "react";

const PrivacyPolicies = () => {
  return (
    <div className="m11c-hp__row">
      <div className="m11c-static__wrap m11c-static__wrap--tnc">
        <div className="m11c-static__box">
          {/* <div className="m11c-static__title">
            <span>1. BOARD OF CONTROL FOR CRICKET IN INDIA </span>
          </div> */}
          <div className="m11c-static__content">
            <p>
              At the Board of Control for Cricket in India (the{" "}
              <strong>“BCCI”</strong>), we are committed to respecting the
              privacy rights of the visitors to our website{" "}
              <a href="http://www.iplt20.com" target="_blank">
                www.iplt20.com
              </a>
              &nbsp;
            </p>
            <p>
              Your privacy is important to us and we aim for our website to be a
              safe and enjoyable environment for our audience. We respect and
              safeguard the personally identifiable information (“
              <strong>Personal Information</strong>”) we receive and collect
              from you on our website and in the course of our other
              interactions online.
            </p>
            <p>
              This Privacy Policy <strong>(“Privacy Policy”)</strong> explains:
            </p>
          </div>
          <div className="m11c-ptSyt__notes">
            <ul>
              <li>what information we may collect about you online;</li>
              <li>
                the use and role of cookies and similar technologies on our
                website;
              </li>
              <li>
                how we will protect and use information we collect about and
                from you;
              </li>
              <li>
                the circumstances in which we might disclose your details to
                anyone else;
              </li>
              <li>when we may use your details to contact you; and</li>
              <li>
                how you can be sure the information we hold about you is
                accurate and current.
              </li>
            </ul>
          </div>
        </div>
        <div className="m11c-static__box">
          <div className="m11c-static__title">
            <span>INFORMATION GATHERED</span>
          </div>
          <div className="m11c-static__content">
            <p>
              In general, you can visit our website without revealing your
              identity or any Personal Information about yourself. However, you
              may not be able to access certain areas or services that require
              registration or need you to reveal your identity and/or other
              information about you.
            </p>
            <p>
              Information that we collect from you will vary depending upon the
              activity you seek to engage in and may include your name, email
              address, phone number, mobile number, home address, date of birth,
              and credit card information. In addition, we may collect
              demographic information such as gender, information about your
              computer, hardware, software, platform, media, Internet Protocol
              (IP) address and connection, information about online activity
              such as feature usage, click paths, and other data that you may
              provide in surveys or online profiles. We may combine demographic
              information with Personal Information to tailor our offerings or
              web pages to your preferences or interests.
            </p>
          </div>
        </div>
        <div className="m11c-static__box">
          <div className="m11c-static__title">
            <span>PERSONAL INFORMATION</span>
          </div>
          <div className="m11c-static__content">
            <p>
              Personal Information means any information that may be used to
              identify you and that is not otherwise publicly available,
              including, but not limited to, your first and last name, home or
              other physical address, email address, phone number or other
              contact information.
            </p>
            <p>
              We may collect Personal Information from you when you register for
              any of our services or otherwise voluntarily provide such
              information. If you wish to subscribe to our newsletter(s) and
              other marketing materials, we will use your name and email address
              to send the newsletter and materials to you.
            </p>
          </div>
        </div>

        <div className="m11c-static__box">
          <div className="m11c-static__title">
            <span>COOKIES AND OTHER TRACKING TECHNOLOGIES </span>
          </div>
          <div className="m11c-static__content">
            <p>
              Some of our web pages may also utilise "cookies" and other
              tracking technologies. A "cookie" is a small text file that may be
              used, for example, to collect information about your activity on
              our website. Some cookies and other technologies may serve to
              recall Personal Information previously indicated by you. Most
              browsers allow you to control cookies, including whether or not to
              accept them and how to remove them. You may set most browsers to
              notify you if you receive a cookie, or you may choose to block
              cookies with your browser, but please note that if you choose to
              erase or block your cookies, you may need to re-enter your
              original user ID and password to gain access to certain parts of
              our website.
            </p>
            <p>
              Tracking technologies may automatically record information such as
              internet domain and host names, other information about your
              geographic location, IP addresses, browser software and operating
              system types, CPU type, your manner of connecting to the Internet
              (e.g., connection speed through narrowband or broadband access),
              click paths, and dates and times that our website is accessed.
            </p>
            <p>
              Our use of cookies and other tracking technologies allows us to
              improve our website and consequently your web experience. We may
              also analyse information that does not include Personal
              Information for trends and statistics.
            </p>
          </div>
        </div>
        <div className="m11c-static__box">
          <div className="m11c-static__title">
            <span>CHILDREN</span>
          </div>
          <div className="m11c-static__content">
            <p>
              Our services and our website are intended for a general audience.
              If you are under the age of 18 years and desire to use this
              website or purchase products or use services offered on our
              website, please request your parent to register with us on your
              behalf and to complete the transaction/s.
            </p>
          </div>
        </div>
        <div className="m11c-static__box">
          <div className="m11c-static__title">
            <span>USES OF PERSONAL INFORMATION</span>
          </div>
          <div className="m11c-static__content">
            <p>
              We may use Personal Information and other information received and
              collected from you to provide the services you have requested,
              including services that display customised content and to contact
              you upon your request and when otherwise necessary. We may also
              use Personal Information for auditing, research and analysis, and
              to operate and improve our services. In certain circumstances, we
              may share aggregated non-personal information with third parties.
              When we use third parties to assist us in processing your Personal
              Information, we require that they comply with our Privacy Policy
              and any other appropriate confidentiality and security measures.
              We may also share such information with third parties in limited
              circumstances, including when complying with legal process,
              preventing fraud or imminent harm, and ensuring the security of
              our network and services.
            </p>
            <p>
              Where we propose to use your Personal Information for any other
              uses, we will ensure that we notify you first. You will also be
              given the opportunity to withhold or withdraw your consent for use
              other than as listed above.
            </p>
          </div>
        </div>
        <div className="m11c-static__box">
          <div className="m11c-static__title">
            <span>CONFIDENTIALITY AND SECURITY</span>
          </div>
          <div className="m11c-static__content">
            <p>
              We will keep confidential and protect your Personal Information
              except where disclosure is required or permitted by law.
            </p>
            <p>
              We follow generally accepted industry standards to protect the
              Personal Information submitted to us, both during transmission
              and, once we receive it, for storage and disposal. When you enter
              sensitive information on our registration or order forms, we
              encrypt that information using secure socket layer (SSL)
              technology. All information we gather is securely stored within
              databases controlled by us. The databases are stored on servers
              secured behind a firewall; access to the servers is
              password-protected and is strictly limited. However, no method of
              transmission over the Internet, or method of electronic storage,
              is 100% secure. Therefore, while we strive to use commercially
              acceptable means to protect your Personal Information, we cannot
              guarantee its absolute security.
            </p>
            <p>
              We limit access to Personal Information to employees/personnel who
              we believe reasonably need to come into contact with that
              information to provide products or services to you or in order to
              do their jobs.
            </p>
            <p>
              Third parties provide certain services available on our website
              and on our behalf. We may provide information, including Personal
              Information, to third-party service providers to help us deliver
              our products, information, and services efficiently and
              effectively. Service providers are also an important means by
              which we maintain our website and mailing lists. We will take
              reasonable steps to ensure that these third-party service
              providers are obligated to protect Personal Information on our
              behalf through confidentiality agreements and otherwise. We do not
              intend to transfer Personal Information without your consent to
              third parties who are not bound to act on our behalf unless such
              transfer is legally required. Similarly, it is against our policy
              to sell Personal Information collected online without consent.
            </p>
            <p>
              If you choose to provide us with your Personal Information, we may
              transfer that Personal Information from your country or
              jurisdiction to other countries or jurisdictions around the world.
              Your Personal Information may be collected and stored on servers
              located in the territory of India and such other countries as we
              may disclose from time to time.
            </p>
          </div>
        </div>
        <div className="m11c-static__box">
          <div className="m11c-static__title">
            <span>THIRD PARTY WEBSITES</span>
          </div>
          <div className="m11c-static__content">
            <p>
              If you click on a link to a third-party site or otherwise leave
              our website, you will go to a website that is outside the purview
              of our control. Because we cannot control the activities of third
              parties, we cannot accept responsibility for any use of your
              Personal Information by such third parties, and we cannot
              guarantee that they will adhere to the same privacy and security
              practices as we do. The use of Personal Information by such
              websites shall be governed by the privacy policies provided
              therein. Therefore, if you visit a third-party website that is
              linked to our website, you should consult that website's privacy
              policy before providing any Personal Information.
            </p>
          </div>
        </div>
        <div className="m11c-static__box">
          <div className="m11c-static__title">
            <span>CONTACTING YOU</span>
          </div>
          <div className="m11c-static__content">
            <p>
              We may contact you using the Personal Information you have given
              us:
              <div class="m11c-ptSyt__notes">
                <ul>
                  <li>
                    in relation to the functioning of any service you have
                    signed up for in order to ensure that we can deliver the
                    services to you;
                  </li>
                  <li>
                    where you have opted to receive further correspondence;
                  </li>
                  <li>
                    to invite you to participate in surveys about our services
                    (participation is always voluntary); and
                  </li>
                  <li>
                    to provide information about our upcoming or new events,
                    products and services, where you have specifically agreed to
                    receive such information.
                  </li>
                </ul>
              </div>
            </p>
          </div>
        </div>
        <div className="m11c-static__box">
          <div className="m11c-static__title">
            <span>CHANGE OF CONTROL</span>
          </div>
          <div className="m11c-static__content">
            <p>
              In the event that ownership or control of our website was to
              change, your Personal Information may be transferred. If such a
              transfer results in a material change in the use of your Personal
              Information, we will provide notice about the choices you have to
              decline to permit such a transfer.
            </p>
          </div>
        </div>
        <div className="m11c-static__box">
          <div className="m11c-static__title">
            <span>ACCURACY</span>
          </div>
          <div className="m11c-static__content">
            <p>
              To the extent that you do provide us with Personal Information, we
              wish to maintain accurate and current Personal Information. Where
              we collect Personal Information from you on our website, should
              you need to update or correct that Personal Information, please
              contact us and we will make reasonable efforts to incorporate the
              changes in your Personal Information that we hold as soon as
              practicable.
            </p>
          </div>
        </div>
        <div className="m11c-static__box">
          <div className="m11c-static__title">
            <span>CONTACT US</span>
          </div>
          <div className="m11c-static__content">
            <p>
              If you have any questions, complaints, comments, concerns,
              feedback or grievances regarding this Privacy Policy or wish to
              obtain the information we currently hold on you, you can contact
              us by emailing us at <a href="office@bcci.tv">office@bcci.tv</a>.
              We will use our best efforts to respond to you or send to you the
              information requested.
            </p>
          </div>
        </div>
        <div className="m11c-static__box">
          <div className="m11c-static__title">
            <span>CONSENT; AMENDMENTS; & LAW</span>
          </div>
          <div className="m11c-static__content">
            <p>
              By using this website, you consent to the terms of this Privacy
              Policy and to our use and management of Personal Information for
              the purposes and in the manner herein provided. Should this
              Privacy Policy change, we intend to take every reasonable step to
              ensure that these changes are brought to your attention by posting
              all changes prominently on our website for a reasonable period of
              time. Your visit and any dispute over privacy are subject to this
              Privacy Policy. The said Policy shall be governed by and construed
              in accordance with the laws of the Republic of India. Further, it
              is irrevocably and unconditionally agreed that the courts of
              Mumbai, India shall have exclusive jurisdiction to entertain any
              proceedings in relation to any disputes arising out of the same.
            </p>
          </div>
        </div>
        <div className="m11c-static__box">
          <div className="m11c-static__title">
            <span>IPL FANTASY GAME</span>
          </div>
          <div className="m11c-static__content">
            <p>
              With respect to the IPL Fantasy Game offered through the web
              portal: fantasy.iplt20.com/ (<strong>“Web Portal”</strong>) and
              any associated mobile application (together, the{" "}
              <strong>“IPL Fantasy Game”</strong>), please note that the
              following supplementary terms shall be applicable to any Personal
              Information submitted thereon.
            </p>
            <p>
              The IPL Fantasy Game is powered by the BCCI’s associate partner -
              My11Circle, a brand of Play Games24x7 Private Limited (
              <strong>“My11Circle”</strong>).
            </p>
            <p>
              The BCCI and My11Circle take your privacy rights seriously, and in
              the context of the IPL Fantasy Game, these supplementary terms
              provide the broad procedure followed by BCCI and My11Circle to
              gather, use, store, disclose and manage your personal data.
              Through these supplementary terms, we would like to explain:
            </p>
            <div class="m11c-ptSyt__notes">
              <ul>
                <li>What Personal Information we may collect about you,</li>
                <li>How we may use or share this information,</li>
                <li>How long we will keep your Personal Information,</li>
                <li>
                  Your choices and rights in relation to your Personal
                  Information with us.
                </li>
              </ul>
            </div>
            <p>
              These supplementary terms apply to any person who registers with
              and/or plays any contest, avails any service or participates in
              any promotion through the IPL Fantasy Game or otherwise accesses
              the IPL Fantasy Game. These supplementary terms apply in addition
              to and shall supersede, in case of any conflict, the general terms
              of this Privacy Policy, the Terms and Conditions governing your
              usage and access of the Website: fantasy.iplt20.com, the IPL
              Fantasy Game{" "}
              <a href="https://fantasy.iplt20.com/classic/more/tnc">
                Terms of Use
              </a>
              {/* <strong>
                <a href="www.iplt20.com"></a>
              </strong> */}
              , and any other terms applicable in relation to your access or use
              of the IPL Fantasy Game or any part thereof. The IPL Fantasy Game,
              the Web Portal and services offered thereon are not available to
              anyone outside India and any person located outside India is not
              permitted to provide personal information to us.
            </p>
          </div>
        </div>

        <div className="m11c-static__box">
          <div className="m11c-static__title">
            <span>Personal Information we may collect about you</span>
          </div>
          <div className="m11c-static__content">
            <p>
              For registering and creating an account with the IPL Fantasy Game,
              we may ask you for the following information about yourself:
            </p>
            <div className="m11c-ptSyt__notes">
              <ul>
                <li>Email Address</li>
                <li>Full Name</li>
                <li>Mobile Number</li>
                <li>Date of Birth</li>
                <li>State of Residence</li>
                <li>Address.</li>
              </ul>
            </div>
            <p>
              In the course of accessing or participating in the IPL Fantasy
              Game, we may access technical information about your device and
              mode of access, including:
            </p>
            <div className="m11c-ptSyt__notes">
              <ul>
                <li>Nature of Device of access (computer, mobile, etc.)</li>
                <li>Internet Protocol Address</li>
                <li>
                  Nature of mode of access (broadband, mobile internet, etc.)
                </li>
                <li>Device ID (Serial Number, IMEI Number, etc.)</li>
                <li>Device Information (make, manufacturer, memory, etc.)</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="m11c-static__box">
          <div className="m11c-static__title">
            <span>How may we use or share this information?</span>
          </div>
          <div className="m11c-static__content">
            <p>
              The Personal Information and other information collected in the
              course of your access, registration and/or usage of the IPL
              Fantasy Game will be available to the BCCI and My11Circle for
              collection, use, storage and sharing, and may be used by either
              the BCCI or My11Circle for the following purposes:
            </p>
            <div className="m11c-ptSyt__notes">
              <ul>
                <li>
                  <b>Providing, improving and developing our services:</b>
                  <p>
                    You consent to the use, storage, processing, disclosure of
                    your Personal Information by us for enabling your access and
                    participation in the IPL Fantasy Game, verifying user
                    accounts, maintaining the accounts of users, completing
                    transactions of the users, for analyzing user behavior and
                    other related requirements, as well as to enable you to
                    participate in any promotion on the IPL Fantasy Game or
                    otherwise access and use the services offered through the
                    IPL Fantasy Game.
                  </p>
                  <p>
                    We may also use software applications for Web Portal traffic
                    analysis, to gather relevant statistics, for advertising
                    purposes and for determining the efficacy and popularity of
                    the IPL Fantasy Game offered through the Web Portal.
                  </p>
                  <p>
                    You consent to your Personal Information being used to track
                    your performance in the IPL Fantasy Game, and tabulate and
                    publish results, declare winners and distribute prize(s) (if
                    any) pursuant to such participation. BCCI and My11Circle may
                    also use cumulative non-personal information for auditing
                    and analysis purposes with the aim of improving its
                    services.
                  </p>
                  <p>
                    We may also use your Personal Information to deal with your
                    requests, enquiries and complaints in relation to the IPL
                    Fantasy Game, and to improve our services, contests and
                    promotions offered through the IPL Fantasy Game, and to
                    better your experience of the same.
                  </p>{" "}
                </li>
                <li>
                  <b>Sharing Data:</b>
                  <p>
                    We may be required to share information received from you,
                    with our employees, agents, service providers and regulatory
                    authorities. We restrict access of personal information to
                    these above-mentioned parties and only allow access to your
                    data on a need-to-know basis in order to process it for
                    providing our services or otherwise if requested by
                    regulatory authorities.
                  </p>
                  <p>
                    We may also use your name, photographs, login credentials
                    and the state from where you are participating when
                    announcing the results of the IPL Fantasy Game on the Web
                    Portal.
                  </p>
                </li>
                <li>
                  <b>Communication:</b>
                  <p>
                    When you provide your email address on the IPL Fantasy Game,
                    you agree to receive email communication from the BCCI and
                    My11Circle as well as partners specifically authorized by
                    BCCI and My11Circle to send out communications relating to
                    the IPL Fantasy Game. We may contact you through different
                    channels of communication about our service, the services
                    provided by the BCCI’s commercial partners and any other
                    matters that we think may interest you.
                  </p>
                  <p>
                    We may also share your information with our personnel,
                    commercial partners and service providers for the purpose of
                    enabling your participation in the IPL Fantasy Game and for
                    the purposes set out above.
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="m11c-static__box">
          <div className="m11c-static__title">
            <span>How long will we keep your Personal Information?</span>
          </div>
          <div className="m11c-static__content">
            <p>
              We will hold and keep your Personal Information for as long as
              needed to complete your usage of the IPL Fantasy Game, and as
              necessary and appropriate for legal compliance, or to exercise our
              rights or remedies under law or contract, or for the purposes of
              our defense in any proceedings instituted against us.
            </p>
            <p>
              We may retain your Personal Information for historic reference and
              record of your performance in the contest(s) and promotion(s) (if
              any) offered through the IPL Fantasy Game.
            </p>
          </div>
        </div>

        <div className="m11c-static__box">
          <div className="m11c-static__title">
            <span>
              Your choices and rights in relation to your Personal Information
              shared with us
            </span>
          </div>
          <div className="m11c-static__content">
            <p>
              You can choose not to share your Personal Information with us, but
              in such case, we may be unable to provide you with access to the
              relevant page or part of the IPL Fantasy Game or the service
              requested by you.
            </p>
            <p>
              When you submit your Personal Information or otherwise register an
              account, access the services or participate in any contest or
              promotion on the IPL Fantasy Game, you hereby consent to the
              collection, use, storage and sharing of such information for the
              purposes set out in this Privacy Policy.
            </p>
            <p>
              Should you have any query on the collection or usage of your
              Personal Information or wish to correct or update any information
              that we have on you, please communicate the same to us at:{" "}
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  window.open("mailto:ipl-support@my11circle.com", "_blank");
                }}
              >
                ipl-support@my11circle.com
              </a>
              , and we will make good faith efforts to respond to your query or
              request within a reasonable period of time, provided that such
              response or action does not: (i) require us to disclose any
              Personal Information of another user or adversely affect the
              rights or wellbeing of any other user; (ii) involve disclosure of
              any confidential, proprietary or sensitive information pertaining
              to us, My11Circle or any other commercial partners/service
              providers of the BCCI; or (iii) adversely affect our rights,
              remedies or interests or; (iv) violate any applicable law or
              rights of third parties.
            </p>
            <p>
              After submitting your Personal Information, you may withdraw your
              consent for the use, storage, collection, disclosure of your
              Personal Information, in the manner set forth in this Privacy
              Policy, by communicating such withdrawal to us at:{" "}
              <a
                href="ipl-support@my11circle.com"
                onClick={(e) => {
                  e.preventDefault();
                  window.open("mailto:ipl-support@my11circle.com", "_blank");
                }}
              >
                ipl-support@my11circle.com
              </a>
            </p>
            <p>
              In case of withdrawal, we may be unable to provide you with the
              services requested by you or permit you to continue to access the
              IPL Fantasy Game or your account thereon, or participate in any
              contest, promotion or service for which such Personal Information
              was collected.
            </p>
            <p>
              Upon withdrawal of consent, we agree to cease any further usage of
              your Personal Information, and (if requested in the withdrawal
              communication) delete any records of your Personal Information,
              unless such processing is necessary to comply with any legal
              obligations or to exercise our rights or remedies under law or
              contract, or for the purposes of our defense in any proceedings
              instituted against us. The aforesaid reservation shall be
              available to and shall permit the processing of your Personal
              Information by the BCCI, My11Circle or any other BCCI commercial
              partner or service provider with whom we share your Personal
              Information as contemplated by this Privacy Policy.
            </p>
            <p>
              Additionally, upon your withdrawal of consent and/or submission of
              a request of deletion of Personal Information, we (or our service
              provider(s) acting under our instructions) may retain such records
              of your Personal Information as are necessary for maintaining a
              historical record of your access and usage of any services,
              performance in any contest(s) or promotions or receipt of any
              prize pursuant to such participation through the IPL Fantasy Game,
              or which are necessary or appropriate for legal compliance or to
              exercise our rights or remedies under law or contract, or for the
              purposes of our defense in any proceedings instituted against us.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicies;
